import { render, staticRenderFns } from "./FbTextField.vue?vue&type=template&id=18b62b9d"
import script from "./FbTextField.vue?vue&type=script&lang=js"
export * from "./FbTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports